/* eslint-disable @typescript-eslint/ban-ts-ignore */
import React, { useEffect } from 'react';
import { loginWith } from 'utils/firebase';
// import { clientApplicationSSOs } from 'services/api-authentication';
import { SSOAuthProvider, SSOAuthProviderKey } from 'entities/sso';
import { ssoAuthProviders } from './sso-auth-providers';
import { SSOButton } from './SSOButton';

type SSOProps = {
  flow: 'login' | 'signup';
  loadingProvider?: SSOAuthProviderKey | null;
  onSuccess?: (key: SSOAuthProviderKey, response: any) => void;
  onError?: (error: any) => void;
  error?: string;
};

export const SSO: React.FC<SSOProps> = ({
  flow,
  loadingProvider,
  onSuccess,
  onError,
  error,
}) => {
  // #region LIFECYCLE
  useEffect(() => {
    // BL: This to get the supported SSO options from the BE
    // clientApplicationSSOs()
    //     .then((response: any) => {
    //         console.log('SSO options => API success:', JSON.stringify(response, null, 2));
    //     })
    //     .catch((error: any) => {
    //         console.error('SSO options => API error', JSON.stringify(error, null, 2));
    //     });
  }, []);
  // #endregion

  // #region HANDLERS
  const handleSSOProviderLogin = (key: SSOAuthProviderKey) => {
    switch (key) {
      case 'APPLE':
      case 'GOOGLE':
        loginWith(
          key,
          (response: any) => {
            onSuccess?.(key, response);
          },
          (error: any) => {
            onError?.(error);
          },
        );
        break;
      default:
        alert(`Auth provider not supported: ${key}`);
    }
  };
  // #endregion

  return (
    <div>
      {error && <div className="mb-2 text-sm text-red-500">{error}</div>}
      {ssoAuthProviders
        // @ts-ignore
        ?.filter((p: SSOAuthProvider) => p.isActive)
        .map((provider: SSOAuthProvider) => (
          <SSOButton
            key={provider.key}
            flow={flow}
            provider={provider}
            isLoading={loadingProvider === provider.key}
            isDisabled={(loadingProvider as string)?.length > 0}
            onLogin={() =>
              handleSSOProviderLogin(provider.key as SSOAuthProviderKey)
            }
          />
        ))}
    </div>
  );
};

export default SSO;
